"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getColumnConfig = void 0;
const button_1 = require("@components/button");
const react_1 = __importDefault(require("react"));
const getColumnConfig = (editHandler) => [
    { width: "60px", cellRender: () => react_1.default.createElement("input", { type: "checkbox" }) },
    {
        title: "Id",
        width: 1,
        cellRender: ({ id }) => id,
    },
    { title: "Name", width: 1, cellRender: ({ title }) => title },
    {
        width: "60px",
        cellRender: (collection) => (react_1.default.createElement(button_1.Button, { type: "primary", onClick: editHandler(collection) }, "Edit")),
    },
];
exports.getColumnConfig = getColumnConfig;
